import { RootState } from "@/store";
import { addCurrentThemeClassToEle } from "@/utils";
import { useSelector } from "react-redux";
import "./seriesProgressBar.css";

const PROGRESS_FILL_GRADIENT =
  "linear-gradient(270deg, #11C700 -2.99%, #F7CF1F 48.51%, #EE502B 100%)";

export default function SeriesProgressBar(props: {
  serie: { progress: number };
}) {
  const raw = props.serie?.progress;
  const progress = Math.max(0, Math.min(100, typeof raw === "number" ? raw : Number(raw) || 0));
  const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

  const showZeroLabel = progress === 0 || progress >= 20;
  const showEndLabel = progress < 80;

  return (
    <div className={`w-full relative ${addCurrentThemeClassToEle(currentTheme, "seriesProgressBar")}`}>
      <div className="progressBarMainCon rounded-full h-[18px] mb-[2px] overflow-hidden">
        {progress > 0 ? (
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${progress}%`,
              background: PROGRESS_FILL_GRADIENT,
            }}
          />
        ) : null}
      </div>

      <div className="relative h-5">
        {showZeroLabel && (
          <span className={`absolute left-0 text-[12px] font-medium textZeroNumber`}>0%</span>
        )}

        {progress > 0 && (
          <span
            className="absolute text-[12px] font-medium textProgressNumber"
            style={{
              left: progress === 100 ? "calc(100% - 12px)" : `${progress}%`,
              transform: progress === 100 ? "none" : "translateX(-50%)",
              transition: "left 0.5s ease",
            }}
          >
            {progress}%
          </span>
        )}

        {showEndLabel && (
          <span className="absolute right-0 text-[12px] font-medium textProgressNumber">100%</span>
        )}
      </div>
    </div>
  );
}
